<template>
  <div>
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-item color="primary" :title="$t('domain.fields.location')" value="1"></v-stepper-item>

        <v-divider></v-divider>

        <v-stepper-item color="primary" :title="$t('common.concepts.details')" value="2"></v-stepper-item>
      </v-stepper-header>
    </v-stepper>
  </div>
  <AddIncidentLocation
    v-if="step == '1'"
    v-model="incident"
    :loading="loading"
    :editting="props.editting"
    @close-incident-location-event="emits('cancel')"
    @open-incident-info-event="step = '2'" />
  <AddIncidentInfo
    v-if="step == '2'"
    v-model="incident"
    :loading="loading"
    :editting="props.editting"
    @close-incident-info-event="step = '1'"
    @save="save" />
  <div class="d-flex bottomShadows flex-grow-0 flex-shrink-1 darkerkBackground justify-content-around">
    <div class="flex-grow-1 pa-2">
      <v-btn
        v-if="step == '1'"
        block
        color="rgb(var(--v-theme-background))"
        variant="flat"
        :loading="loading"
        :to="{ name: `incidentlist` }">
        {{ $t('common.actions.cancel') }}
      </v-btn>
      <v-btn v-else block color="rgb(var(--v-theme-background))" variant="flat" :loading="loading" @click="step = '1'">
        {{ $t('common.actions.back') }}
      </v-btn>
    </div>
    <div class="flex-grow-1 pa-2">
      <v-btn
        v-if="step == '1'"
        block
        color="rgb(var(--v-theme-primary))"
        :disabled="incident.latitude === undefined || incident.longitude === undefined"
        variant="flat"
        @click="step = '2'">
        {{ $t('common.actions.next') }}
      </v-btn>
      <v-btn
        v-else
        block
        color="primary"
        :loading="loading"
        variant="flat"
        :disabled="
          !incident.name || !incident.declared_timestamp || !incident.category?.id || !incident.complexity?.id || !incident.measurements
        "
        @click="save">
        {{ $t('common.actions.save') }}
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { onBeforeUnmount, ref, watch } from 'vue'

import { storeToRefs } from 'pinia'

import { useVModel } from '@vueuse/core'

import MarkerStore from '@/stores/markerStore'
import type { Incident } from '@/types/Incident'

import AddIncidentInfo from './AddIncidentInfo.vue'
import AddIncidentLocation from './AddIncidentLocation.vue'

const props = defineProps({
  modelValue: { type: Object as PropType<Partial<Incident>>, required: true },
  editting: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits<{
  (event: 'save', v: Incident): void
  (event: 'cancel'): void
  (event: 'update:modelValue', v: Incident): void
}>()

const incident = useVModel(props, 'modelValue', emits, { deep: true })

const loading = ref(false)

const markerStore = MarkerStore()
const { markerCoordinates, enableMarker } = storeToRefs(markerStore)
enableMarker.value = true

watch(markerCoordinates, (value) => {
  if (value && value.latitude && value.longitude) {
    incident.value.latitude = value.latitude
    incident.value.longitude = value.longitude
  }
})

const step = ref('1')

async function save() {
  loading.value = true
  emits('update:modelValue', incident.value as Incident)
  emits('save', incident.value as Incident)
}

onBeforeUnmount(() => {
  enableMarker.value = false
})
</script>
